import Vue from 'vue'
import { createReactionsModule } from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '../../../api/kvSync'
import kvSyncSubscriber from '../../../mqtt/kvSync'
import config from '../../../config'

export default createReactionsModule({
  Vue,
  config,
  getKvSyncApi,
  kvSyncMqttSubscriber: kvSyncSubscriber,
})
